import nl from './nl.js'
import en from './en.js'
import de from './de.js'
import ch from './ch.js'
import fr from './fr.js'
import it from './it.js'
import TokenService from '@/services/storage.service'

let lang = {}

const resolveLangByCountry = () => {
  const currentCountry = localStorage.getItem('currentCountry')?.toLowerCase()
  const countryFromUrl = window.location.hostname
    .match(/^(?:dev)?admin-plus-([a-z]{2})\.bsplus\.bridgestone\.eu$/i)?.[1]
    ?.toLowerCase()
  const countryCode = currentCountry || countryFromUrl

  if (countryCode === 'ch') {
    return 'ch'
  }

  if (countryCode === 'de') {
    return 'de'
  }

  if (countryCode === 'nl') {
    return 'nl'
  }

  return 'en'
}

const setUpLang = () => {
  const defaultLang = resolveLangByCountry()
  const storedLang = TokenService.getLang()
  const allowedLangs = ['en', 'de', 'nl', 'ch', 'fr', 'it']

  let appLang = storedLang

  if (!appLang || !allowedLangs.includes(appLang)) {
    appLang = defaultLang
  }

  if (defaultLang === 'nl' && !['nl', 'en'].includes(appLang)) {
    appLang = 'nl'
  }

  TokenService.setLang(appLang)
  lang = appLang

  return lang
}

setUpLang()

const messages = {
  en,
  de,
  nl,
  ch,
  fr,
  it
}

export default messages
